import BorderGlow from "../../components/common/BorderGlow";
import ThemeToggle from "../auth/ThemeToggle";
import LandingFeatureDock from "./LandingFeatureDock";
import LandingFooter from "./LandingFooter";
import LandingScrollCta from "./LandingScrollCta";

const FEATURE_CARDS = [
  "ROI automático",
  "ABI atualizado",
  "Lucro real",
  "Evolução da banca",
  "Histórico de torneios",
];

const PREVIEW_ROWS = [
  ["Sunday Builder", "$55", "$340"],
  ["Daily Special", "$22", "$0"],
  ["Turbo Stack", "$16,50", "$96"],
];

const PREVIEW_METRICS = [
  { label: "ROI", value: "38,6%", tone: "profit" },
  { label: "ABI", value: "$31,20", tone: "base" },
  { label: "Lucro", value: "$842", tone: "growth" },
];

const PREVIEW_POINTS = [
  { x: 7, y: 66, value: "$0" },
  { x: 24, y: 54, value: "+$184" },
  { x: 41, y: 59, value: "+$96" },
  { x: 58, y: 39, value: "+$512" },
  { x: 75, y: 28, value: "+$840" },
  { x: 93, y: 18, value: "+$1.284" },
];

const PREVIEW_LINE_POINTS = PREVIEW_POINTS.map(({ x, y }) => `${x},${y}`).join(
  " "
);

export default function PublicLanding({
  theme,
  onThemeToggle,
  onAuthRouteRequest,
}) {
  const kpiBackground =
    theme === "light" ? "rgba(255, 255, 255, 0.72)" : "rgba(15, 13, 18, 0.82)";

  return (
    <main className="landing-page">
      <section className="landing-hero" aria-labelledby="landing-hero-title">
        <header className="landing-header">
          <nav className="landing-nav" aria-label="Navegação pública">
            <div className="landing-brand">
              <img
                src={`${process.env.PUBLIC_URL || ""}/suptracker.png`}
                alt=""
                className="landing-brand__logo"
              />
              <span>orion33</span>
              <ThemeToggle
                theme={theme}
                onToggle={onThemeToggle}
                className="theme-toggle--landing-brand"
              />
            </div>
            <div className="landing-nav__actions">
              <button
                className="landing-nav__login"
                type="button"
                onClick={() => onAuthRouteRequest("signin")}
              >
                Entrar
              </button>
            </div>
          </nav>
        </header>

        <div className="landing-hero__content">
          <div className="landing-hero__copy">
            <h1 id="landing-hero-title">
              Controle sua banca de poker sem planilhas, contas manuais ou
              bagunça.
            </h1>
            <p>
              Registre torneios, buy-ins e premiações. O orion33 calcula
              automaticamente ROI, ABI, lucro e evolução da banca em uma
              plataforma completa e pronta para usar.
            </p>
            <div className="landing-hero__actions" aria-label="Ações iniciais">
              <button
                className="landing-button landing-button--primary"
                type="button"
                onClick={() => onAuthRouteRequest("signup")}
              >
                Começar agora
              </button>
              <button
                className="landing-button landing-button--secondary"
                type="button"
                onClick={() => onAuthRouteRequest("signin")}
              >
                Ver como funciona
              </button>
            </div>
          </div>

          <div
            className="landing-product-preview"
            aria-label="Prévia visual dos indicadores do orion33"
          >
            <div className="landing-product-preview__metrics">
              {PREVIEW_METRICS.map(({ label, value, tone }) => (
                <BorderGlow
                  key={label}
                  className={`landing-product-preview__metric landing-product-preview__metric--${tone}`}
                  edgeSensitivity={22}
                  glowColor="40 80 80"
                  backgroundColor={kpiBackground}
                  borderRadius={8}
                  glowRadius={28}
                  glowIntensity={0.9}
                  coneSpread={24}
                  animated
                  fillOpacity={0}
                  colors={["#f8b822", "#ffeba9", "#a57100"]}
                >
                  <span>{label}</span>
                  <strong>{value}</strong>
                </BorderGlow>
              ))}
            </div>

            <div
              className="landing-product-preview__chart"
              aria-label="Lucro em linha"
            >
              <div className="landing-product-preview__chart-top">
                <span>Lucro</span>
                <strong>+ $1.284</strong>
              </div>
              <svg
                className="landing-product-preview__line-chart"
                viewBox="0 0 100 80"
                role="img"
                aria-label="Lucro acumulado com marcadores de valor"
              >
                <g className="landing-product-preview__grid" aria-hidden="true">
                  <line x1="0" x2="100" y1="20" y2="20" />
                  <line x1="0" x2="100" y1="40" y2="40" />
                  <line x1="0" x2="100" y1="60" y2="60" />
                </g>
                <polyline
                  className="landing-product-preview__line-shadow"
                  points={PREVIEW_LINE_POINTS}
                />
                <polyline
                  className="landing-product-preview__line"
                  points={PREVIEW_LINE_POINTS}
                />
                {PREVIEW_POINTS.map(({ x, y, value }) => (
                  <g className="landing-product-preview__marker" key={value}>
                    <circle cx={x} cy={y} r="1.35" />
                    <text x={x} y={Math.max(y - 6, 8)}>
                      {value}
                    </text>
                  </g>
                ))}
              </svg>
            </div>

            <div className="landing-product-preview__rows">
              {PREVIEW_ROWS.map(([name, , prize]) => (
                <div className="landing-product-preview__row" key={name}>
                  <span>{name}</span>
                  <strong>{prize}</strong>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section
        className="landing-section landing-section--pain"
        aria-labelledby="landing-pain-title"
      >
        <div className="landing-section__content">
          <h2 id="landing-pain-title">Pare de jogar no escuro.</h2>
          <p>
            Sem Excel, sem cálculo manual e sem registros espalhados. Veja
            quanto você investe, quanto retorna e como sua banca evolui com
            dados reais.
          </p>
        </div>
        <LandingFeatureDock features={FEATURE_CARDS} />
      </section>

      <section
        className="landing-section landing-section--solution"
        aria-labelledby="landing-solution-title"
      >
        <div className="landing-section__content landing-section__content--wide">
          <div>
            <h2 id="landing-solution-title">
              O jeito mais simples de controlar sua banca e resultados no
              poker.
            </h2>
            <p>
              Organize seus torneios, acompanhe seus principais indicadores e
              entenda sua performance sem depender de fórmulas, abas ou
              controles improvisados.
            </p>
          </div>
          <LandingScrollCta onClick={() => onAuthRouteRequest("signup")} />
        </div>
      </section>

      <LandingFooter />
    </main>
  );
}
